const LocationCheckedIcon = ({ size = 11, fill = '#CE181E' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 8 10"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.475 5.675L5.95 3.2L5.2375 2.4875L3.475 4.25L2.775 3.55L2.0625 4.2625L3.475 5.675ZM4 10C2.65833 8.85833 1.65625 7.79792 0.99375 6.81875C0.33125 5.83958 0 4.93333 0 4.1C0 2.85 0.402083 1.85417 1.20625 1.1125C2.01042 0.370833 2.94167 0 4 0C5.05833 0 5.98958 0.370833 6.79375 1.1125C7.59792 1.85417 8 2.85 8 4.1C8 4.93333 7.66875 5.83958 7.00625 6.81875C6.34375 7.79792 5.34167 8.85833 4 10Z"
        fill={fill}
      />
    </svg>
  );
};

export default LocationCheckedIcon;
